import { InputValidationComponent } from 'core/validation/input/input-validation.component'
import { FormValidationComponent } from 'core/validation/form/form-validation.component'
import { ModalAvisemeObserver } from './modal-aviseme.observer'
import { ModalAviseService } from './modal-aviseme.service'
import { constraints } from './constraints'
import { AvisemeMask } from './masks'
import { Observable } from 'rxjs'
import { ToggleClass } from 'core/toggleClass';

export class ModalAvisemeComponent {
    constructor() {
        this.modalSelector = document.querySelectorAll('[data-modal="aviseme"]')
        this.avisemeForm = document.querySelector("#aviseme-form")
        this.modalAviseme = document.querySelector('.modal-aviseme')
        this.submitStream = Observable.fromEvent(this.avisemeForm, 'submit')
        this.masks = new AvisemeMask()
        this.validator = new FormValidationComponent(this.avisemeForm, constraints)
        this.service = new ModalAviseService()
        this.init()
    }

    init() {

        if(this.avisemeForm) {
            //Submit Avise-me Event
            this.submitStream
                .do(event => event.preventDefault())
                .filter(() => this.validator.validateForm())
                .map(event => this.validator.serializeForm())
                .subscribe(request => this.aviseme(request))
        }

        //Change Input Event Component
        new InputValidationComponent(this.avisemeForm, constraints).init()

        //Modal Aviseme Toggle Click
        new ToggleClass(this.modalSettings())

    }

    aviseme(request) {
        return this.service
                    .aviseme(request)
                    .subscribe(new ModalAvisemeObserver());
    }

    modalSettings() {
        return {
            selector: this.modalSelector,
            target: this.modalAviseme,
            class: 'modal--active',
            callback: this.modalCallback.bind(this),
            blockBodyScroll: true
        }
    }

    modalCallback(event, hasClass) {
        if(hasClass) {
            this.avisemeForm.reset()
            const item = event.target.getAttribute('data-item')
            if(item)
                this.avisemeForm.codigoItem.value = item
            
            if(this.modalAviseme.classList.contains('modal-aviseme--success'))
                this.modalAviseme.classList.remove('modal-aviseme--success')
        }        
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-aviseme/modal-aviseme.component.js